<div (resized)="onResized($event)" class="chart-container">
    <div [ngClass]="{'hc-chart' : !isInWizard}" [chart]="chart"></div>
</div>
